import momentTimezone from 'moment-timezone';
// Constants
import { shortDateTimeZoneFormat } from 'constants/global';

/** The start shows in the venue's time zone, with the zone named, whatever the admin's browser zone. */
export const getTicketEventOptionTitle = ({
  name,
  startsAt,
  timezone,
}: {
  name: string;
  startsAt: string;
  timezone: string;
}): string =>
  `${name} (${momentTimezone(startsAt)
    .tz(timezone)
    .format(shortDateTimeZoneFormat)})`;
